export const success = "success";
